import React from "react";
import { Spin } from "antd";
import styled, { css } from "styled-components";

type ContentLoadingProps = {
  spinning: boolean;
  children: React.ReactNode;
  minHeight?: number;
  fill?: boolean;
};

const ContentLoading: React.FC<ContentLoadingProps> = ({
  spinning,
  children,
  minHeight = 240,
  fill = false,
}) => (
  <Wrap $minHeight={minHeight} $fill={fill}>
    {children}
    {spinning ? (
      <Overlay role="status" aria-live="polite" aria-busy="true">
        <Spin />
      </Overlay>
    ) : null}
  </Wrap>
);

const Wrap = styled.div<{ $minHeight: number; $fill: boolean }>`
  position: relative;
  width: 100%;
  min-width: 0;
  align-self: stretch;
  min-height: ${({ $minHeight }) => $minHeight}px;
  ${({ $fill }) =>
    $fill
      ? `
    flex: 1;
    height: 100%;
    min-height: 100%;
  `
      : ""}
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(249, 250, 251, 0.72);
  cursor: wait;
`;

export const filterControlCss = css`
  transition: background 140ms ease, color 140ms ease, border-color 140ms ease;

  &:hover:not(:disabled) {
    filter: brightness(0.97);
  }

  &:active:not(:disabled) {
    filter: brightness(0.93);
  }
`;

export default ContentLoading;
